import { Icon } from '@iconify/react';
import { useState } from 'react';

import { cn } from '@/lib/utils';

import Button from '../Button';
import AuthLinkWithDialog from '../CandidateAuth/AuthLinkWithDialog';
import Text from '../Text';

const FEATURES = [
  { label: 'ATS Pass', icon: 'material-symbols:document-scanner-outline' },
  { label: 'Missing keywords', icon: 'material-symbols:key-outline' },
  {
    label: 'Tailored AI suggestions',
    icon: 'material-symbols:lightbulb-outline',
  },
  { label: 'Job match analysis', icon: 'material-symbols:manage-search' },
  {
    label: 'Interview-focused insights',
    icon: 'material-symbols:chat-bubble-outline',
  },
];

const PremiumUpsellBottomBanner = ({ className }: { className?: string }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;
  return (
    <div
      className={cn(
        `sticky bottom-0 w-full bg-jb-primary-200 md:px-16 px-6 py-6 flex flex-col md:gap-2 gap-4 z-10`,
        className
      )}
    >
      <div className="flex flex-row items-center gap-4">
        <Icon
          icon="material-symbols:crown"
          className="text-jb-primary-500"
          fontSize={24}
        />
        <Text variant="jb-h5" className="font-semibold text-jb-primary-500">
          Unlock Full Resume Report
        </Text>
      </div>
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="hidden flex-row flex-wrap gap-8 md:flex">
          {FEATURES.map(({ icon, label }) => (
            <div
              key={label}
              className="flex flex-row items-center justify-start gap-2"
            >
              <Icon icon={icon} fontSize={20} className="text-jb-primary-500" />
              <Text variant="jb-body-medium" className="text-jb-neutral-800">
                {label}
              </Text>
            </div>
          ))}
        </div>
        <AuthLinkWithDialog href="/builder">
          <Button
            variant="jbPrimary"
            suffixIcon="material-symbols:docs"
            tabIndex={-1}
          >
            Check your resume
          </Button>
        </AuthLinkWithDialog>
      </div>
      <Button
        onClick={() => setIsOpen(false)}
        variant="unstyled"
        prefixIcon="material-symbols:close-rounded"
        className="absolute right-1 top-1 text-jb-neutral-1000"
      />
    </div>
  );
};

export default PremiumUpsellBottomBanner;
